import { hasVerifiedRobotNumber } from './robotSelection';

const selectedId = id => (id && id !== 'none' ? String(id) : '');

// Update saved ownership without replacing drafts, names, checkbox or online state.
export function reconcileStudentCache(students, data, robots, previousRobots = new Map()) {
  const ownership = new Map(data.studentRobots.map(row => [String(row._id), row.robots]));
  return Object.entries(students || {}).reduce((result, [id, student]) => {
    const ids = ownership.get(String(student.studentClassRoomId));
    if (student.isNew || !ids) { result[id] = student; return result; }
    const savedRobot = student.robots && student.robots[0];
    const savedId = student.robots ? (savedRobot && (savedRobot._id || savedRobot)) : student.robotId;
    const dirty = selectedId(student.robotId) !== selectedId(savedId);
    let robotId = dirty ? student.robotId : ids[0];
    if (dirty && selectedId(robotId)) {
      const oldRobot = previousRobots.get(robotId);
      const current = robots.get(robotId);
      const replacement = oldRobot && (!current || current.identifier !== oldRobot.identifier) &&
        data.robots.find(robot => hasVerifiedRobotNumber(robot) && robot.identifier === oldRobot.identifier);
      if (replacement) robotId = replacement._id;
    }
    result[id] = { ...student, robotId, robots: ids.map(mac => robots.get(mac)).filter(Boolean) };
    return result;
  }, {});
}
